// removed by extract-text-webpack-plugin
module.exports = {"text800":"_20co9TK31KQ3IqtqbJPAmM","text700":"_2CUQfWZs5LZuSLF0OaZb-y","text600":"_3WHnRN17GyGLAT_WbWv9Zz","text500":"iHGcGW4wqSSeTd7oZWhFF","text400":"_2Xp39rlfieOV-89yokiAtP","text300":"_39n1m-Akl3t-Hp9fJxAHUm","text200":"_1fnxq04KuRv8__mxYjlpv0","textParagraph":"_1qRxsQQ4phUUHPna385a","crimp":"_258U4thyWbQp-KcLD4VaJk","trim":"_3nngUl7HDdZftpg3_6RTaT","flexCenter":"_2ENpKG5UGqjftglIQPE6bX","hideTextOverflow":"_3RKdkmkrtRYUtDl3wafXxx","marginPageMainContent":"_3Db8LQGiy-8wOeByr-3R5y"};


//////////////////
// WEBPACK FOOTER
// ./src/imports/styles/extend.menu.scss
// module id = 820
// module chunks = 0